import moment from "moment";
import { Card, CardBody, Table } from "reactstrap";
import { useUrenoverzichtContext } from "./context/UrenoverzichtContext";

const PeriodOverview = () => {
	const { startDate, endDate, hoursData } = useUrenoverzichtContext();
	return (
		<Card className="main-card">
			<CardBody className="d-flex flex-column">
				<h5 className="mb-4">Periode-overzicht</h5>
				<div className="row">
					<div className="col-lg-6">
						<div className="table-wrapper">							
						<Table size="sm" className="mb-0 table  table-sm table-hover">
							<thead>
								<tr>
									<th>Periode</th>
									<th>Uren totaal</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{moment(startDate).format("DD-MM-yyyy") +
											" t/m " +
											moment(endDate).format("DD-MM-yyyy")}
									</td>
									<td>{hoursData?.arrTotal?.uren}</td>
								</tr>
							</tbody>
						</Table>
						</div>
					</div>
				</div>
			</CardBody>
		</Card>
	);
};

export default PeriodOverview;
